import {
  type ContractData,
  type ProductOfDayDataType,
} from '@/common/types/contract';

const checkIfContractHasProductOfDay = (
  productOfDayContractList: ProductOfDayDataType[] | null,
  contract?: ContractData,
): boolean => {
  if (!contract || !productOfDayContractList) {
    return false;
  }

  return productOfDayContractList.some(({ name }) =>
    Object.keys(contract).includes(name),
  );
};

export { checkIfContractHasProductOfDay };
